import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const StatusMessage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { message, success } = location.state || {};

  if (!message) {
    // If no message passed, redirect home or elsewhere
    navigate("/");
    return null;
  }

  return (
    <div className="max-w-lg mx-auto p-6 mt-10 text-center">
      <h2
        className={`text-2xl font-bold mb-4 ${success ? "text-green-600" : "text-red-600"}`}
      >
        {success ? "Success!" : "Error!"}
      </h2>
      <p className="mb-6">{message}</p>
      <button
        onClick={() => navigate("/ProviderProfilePage")}
        className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
      >
        Go to Home
      </button>
    </div>
  );
};

export default StatusMessage;
